import { ReactElement } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow, Typography
} from "@mui/material";
import { IBilletTons } from "../types";
import { formatNumber } from "../../../../../system/utils";
import StyledTableRow from "../../../../../components/styledTableRow";
import TableContainer  from "../../../../../components/tableContainer";

interface IBilletTonsProps {
  data: IBilletTons[];
}


const AvgBilletTonsTable = ({ data }: IBilletTonsProps): ReactElement => {
  const tableContent: { crewName: string, total: number, count: number, }[] = [];

  data.forEach(row => {
    let crewData = tableContent.find((x: any) => x.crewName === row.crewName);

    if (!crewData) {
      crewData = {
        crewName: row.crewName,
        count: 0,
        total: 0,
      };

      tableContent.push(crewData);
    }

    crewData.count += 1;
    crewData.total += row.total;
  });

  let total = 0;
  tableContent.forEach(row => total += row.count > 0 ? row.total / row.count : 0);

  total = tableContent.length > 0 ? total / tableContent.length : 0;

  // Consolidated styles to avoid duplicate `style` props on the same element
  const headerCellStyle = { backgroundColor: "#b0bec5" } as const;
  const footerCellBaseStyle = { backgroundColor: "#b0bec5", fontWeight: "bold" } as const;

  return (
    <TableContainer >
      <Typography variant="h5">
        Average billet tons by Crew
      </Typography>
      <Table stickyHeader={true} size={"small"}>
        <TableHead>
          <TableRow>
            <TableCell
              align="left"
              style={{ ...headerCellStyle, minWidth: 60 }}>
              Crew
            </TableCell>

            <TableCell
              align="right"
              style={{ ...headerCellStyle, minWidth: 60 }}>
              Average
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {tableContent.map((row: any, index: number) => {
            return (
              <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`day-row-${index}`}>
                <TableCell align="left">
                  {row.crewName}
                </TableCell>

                <TableCell align="right">
                  {row.count > 0 ? formatNumber(row.total / row.count, 1) : 0.0}
                </TableCell>
              </StyledTableRow>
            );
          })
          }
          <TableRow>
            <TableCell
              align="left"
              style={{ ...footerCellBaseStyle, width: 60 }}>
              Total
            </TableCell>

            <TableCell
              align="right"
              style={{ ...footerCellBaseStyle, width: 60 }}>
              {formatNumber(total, 1)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AvgBilletTonsTable;
